import { render, staticRenderFns } from "./CompanySelect.vue?vue&type=template&id=b9dc062e&scoped=true&"
import script from "./CompanySelect.vue?vue&type=script&lang=js&"
export * from "./CompanySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dc062e",
  null
  
)

export default component.exports